import React from "react";
import { useTranslation } from "react-i18next";
import AccountsIcon from "@icons/accounts.svg?react";
import { toCurrency } from "@helpers";
import { MiniCardChart } from "@components/Chart";
import { NoAccountsMiniCard } from "@components/Card";
import { useCashBalance } from "@features/dashboard/hooks";
import { LoadingPlaceHolder } from "../../common/progress/LoadingPlaceHolder";

export interface CashAccountsProps {
  areAccountsLoading: boolean;
  cashAccountsIds?: number[];
  balance?: number;
  onAddAccountsClick: () => void;
  onClick: () => void;
  height?: string;
}

export const CashAccountsCard = ({
  areAccountsLoading,
  cashAccountsIds,
  balance,
  onAddAccountsClick,
  onClick,
  height,
}: CashAccountsProps) => {
  const { t } = useTranslation();
  const { chartData, isFetching } = useCashBalance(cashAccountsIds || []);

  if (isFetching || areAccountsLoading) {
    return <LoadingPlaceHolder height={height} />;
  }
  return (
    <>
      {cashAccountsIds?.length === 0 && (
        <NoAccountsMiniCard
          onClick={onAddAccountsClick}
          icon={<AccountsIcon width="24px" height="24px" />}
          title={t("domains.cashAccountsCard.noAccountsTitle")}
          subtitle={t("domains.cashAccountsCard.noAccountsSubtitle")}
          buttonText={t("domains.cashAccountsCard.noAccountsButtonText")}
          height={height}
        />
      )}
      {(cashAccountsIds?.length || 0) > 0 &&
        chartData &&
        chartData?.length > 0 && (
          <MiniCardChart
            onClick={onClick}
            icon={<AccountsIcon width="24px" height="24px" />}
            data={chartData || []}
            headline={toCurrency(balance, "EUR")}
            title={t("domains.cashAccountsCard.title")}
            subtitle={t("domains.cashAccountsCard.subtitle", {
              count: cashAccountsIds?.length,
            })}
            percentPrefix={`${t("domains.cashAccountsCard.percentPrefix")}`}
            height={height}
          />
        )}
    </>
  );
};
